import { z } from 'zod';

export const DetectedObjectSchema = z.object({
  article: z.enum(['der', 'die', 'das']).optional(),
  confidence: z.number().min(0).max(1),
  name: z.string().min(1, 'Name cannot be empty'),
});

export const AnalyzeImageResponseSchema = z.object({
  detectedObjects: z.array(DetectedObjectSchema),
});

export type IDetectedObjectDto = z.infer<typeof DetectedObjectSchema>;
export type IAnalyzeImageResponseDto = z.infer<
  typeof AnalyzeImageResponseSchema
>;
